export class MenuAreaModel {
  id: number;
  hotel_id: number;
  title: string;
  hide: boolean;

  constructor(id = 0,
              hotel_id = 0,
              title = '',
              hide = false) {
    this.id = id;
    this.hotel_id = hotel_id;
    this.title = title;
    this.hide = hide;
  }
}
